const initialState = () => ({
  accumulatedSalesKpiData: [],
  chartData: [],
  storeGrowthData: [],
  loading: false,
  selectedMetricOption: {}
})

const state = initialState()

const getters = {

}

const mutations = {
  commit_sellOutDashboardCard_accumulatedSalesKpiData (state, accumulatedSalesKpiData) {
    state.accumulatedSalesKpiData = accumulatedSalesKpiData
  },
  commit_sellOutDashboardCard_loading (state, loading) {
    state.loading = loading
  },
  commit_sellOutDashboardCard_selectedMetricOption (state, selectedMetricOption) {
    state.selectedMetricOption = selectedMetricOption
  },
  commit_sellOutDashboardCard_storeGrowthData (state, storeGrowthData) {
    this.state.storeGrowthData = storeGrowthData
  },
  commit_sellOutDashboardCard_resetState (state) {
    const newState = initialState()
    Object.keys(newState).forEach(key => {
      state[key] = newState[key]
    })
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/sellOutDashboardCard.js